import dynamic from 'next/dynamic';

import { ArticleSection } from 'editorial/components/ArticleSection';
import { IArticleSectionAdditionalProps, IArticleTextSection } from 'editorial/types';

const ArticleParagraph = dynamic(() => import('editorial/components/ArticleParagraph'), {
  ssr: false,
});

export const ArticleTextSection = ({
  text,
  textAlignment,
}: IArticleTextSection &
  IArticleSectionAdditionalProps & {
    textAlignment?: 'center' | 'left' | 'right';
    type: string;
  }) => {
  return (
    <ArticleSection>
      <ArticleParagraph text={text} textAlignment={textAlignment} />
    </ArticleSection>
  );
};
